import { createContext, useContext } from 'react'

export type DashboardMetricVariant = 'card' | 'plain'

type DashboardMetricGridContextValue = {
  showIcons: boolean
  variant: DashboardMetricVariant
}

const DashboardMetricGridContext = createContext<DashboardMetricGridContextValue>({
  showIcons: true,
  variant: 'card',
})

export function useDashboardMetricGridContext(): DashboardMetricGridContextValue {
  return useContext(DashboardMetricGridContext)
}

export const DashboardMetricGridProvider = DashboardMetricGridContext.Provider
